import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import {CheckOutlined} from '@material-ui/icons';
import DataGrid from '../../../shared/datagrid/DataGrid.tsx';
import ContainedButton from '../../../shared/buttons/ContainedButton.tsx';
import TextButton from '../../../shared/buttons/TextButton.tsx';
import {formatarCpf} from '../../components/inscricao/inscricaoAdministrativaPayload.js';
import {ouTraco} from '../../components/inscricao/documentoInscricao.js';

const useStyles = makeStyles(theme => ({
    root: {
        width: 800
    },
    contentRoot: {
        overflowY: 'initial'
    },
    orientacao: {
        marginBottom: theme.spacing(2)
    }
}));

/*
 * Cadastros já existentes com o CPF digitado na criação da inscrição
 * (_formSelecionarPessoa do PrimeFaces). Ao escolher, a página carrega os dados
 * da pessoa e da última inscrição dela.
 */
export default function DialogSelecionarPessoa({open, onClose, pessoas = [], onSelecionar}) {
    const classes = useStyles();
    const [selecionada, setSelecionada] = useState(null);

    const onEntering = () => setSelecionada(pessoas.length === 1 ? pessoas[0] : null);

    const selecionar = () => {
        if (selecionada) {
            onSelecionar(selecionada);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} TransitionProps={{onEntering}} scroll='body'
                aria-labelledby='dialog-selecionar-pessoa-titulo' classes={{paper: classes.root}}>
            <DialogTitle id='dialog-selecionar-pessoa-titulo'>Selecionar cadastro já existente</DialogTitle>
            <DialogContent classes={{root: classes.contentRoot}}>
                <Typography variant='body2' className={classes.orientacao}>
                    Já existe cadastro com este CPF. Selecione a pessoa para carregar os dados dela e da última inscrição.
                </Typography>
                <DataGrid
                    rows={pessoas}
                    comparatorKeys={['idPessoa']}
                    tableContainerProps={{component: 'div'}}
                    select
                    selectOptions={{
                        mode: 'single',
                        selectedRows: selecionada ? [selecionada] : [],
                        onSelect: pessoa => setSelecionada(pessoa)
                    }}
                    noRecordsText='Nenhuma pessoa registrada com esse CPF.'
                    columns={[
                        {label: 'CPF', field: 'cpf', valueGetter: valor => ouTraco(formatarCpf(valor))},
                        {label: 'Nome', field: 'nome', valueGetter: valor => ouTraco(valor)},
                        {label: 'Data de nascimento', field: 'dataNascimento', valueGetter: valor => ouTraco(valor)}
                    ]}/>
            </DialogContent>
            <DialogActions>
                <TextButton onClick={onClose}>Fechar</TextButton>
                <ContainedButton startIcon={<CheckOutlined/>} disabled={!selecionada} onClick={selecionar}>
                    Selecionar
                </ContainedButton>
            </DialogActions>
        </Dialog>
    );
}

DialogSelecionarPessoa.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    pessoas: PropTypes.array,
    onSelecionar: PropTypes.func.isRequired
};
